import { render, staticRenderFns } from "./VehicleCommercial.vue?vue&type=template&id=1b7f29e6&"
import script from "./VehicleCommercial.vue?vue&type=script&lang=js&"
export * from "./VehicleCommercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports